// extracted by mini-css-extract-plugin
export default {"container":"CpwfN5ZfeVHqsMG3qguU"};